            <!-- Content Wrapper Start -->
            <div class="fm-content-wrapper fm-lovedone-page">
                <div class="container-fluid">
                   <div class="row">
                        <div class="col-12">
                            <!-- Page Title -->
                            <div class="fm-page-title">
                                <h2 class="fm-head-24 fm-title mb-2">Loved Ones & Family Tree</h2>
                                <p>Your family circle - keeping memories alive together</p>
                            </div>

                            @if (isInitializing()) {
                              <!-- Skeleton / loading state -->
                              <div class="fm-cards-group">
                                <div class="row g-3">
                                  <div class="col-sm-6 col-lg-4 col-xl-3">
                                    <div class="fm-white-column fm-card-icon fm-metric-card">
                                      <div class="fm-card-content">
                                        <h3 class="fm-head-32 fm-title">—</h3>
                                        <p class="fm-large mb-0">Family Members</p>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col-sm-6 col-lg-4 col-xl-3">
                                    <div class="fm-white-column fm-card-icon fm-metric-card">
                                      <div class="fm-card-content">
                                        <h3 class="fm-head-32 fm-title">—</h3>
                                        <p class="fm-large mb-0">Total Stories</p>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col-sm-6 col-lg-4 col-xl-3">
                                    <div class="fm-white-column fm-card-icon fm-metric-card">
                                      <div class="fm-card-content">
                                        <h3 class="fm-head-32 fm-title">—</h3>
                                        <p class="fm-large mb-0">Avg stories per person</p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            } @else if (hasError()) {
                              <div class="fm-white-column text-center mt-4">
                                <p class="mb-0">Something went wrong. Please refresh and try again.</p>
                              </div>
                            } @else {
                            <!-- Card Group Cards -->
                            <div class="fm-cards-group">
                                <div class="row g-3">
                                    <div class="col-sm-6 col-lg-4 col-xl-3">
                                        <div class="fm-white-column fm-card-icon fm-metric-card">
                                            <div class="fm-card-content">
                                                <h3 class="fm-head-32 fm-title">{{ summaryCount().familyMembersCount }}</h3>
                                                <p class="fm-large mb-0">Family Members</p>
                                            </div>
                                            <div class="fm-metric-icon">
                                                <img src="images/icons/fm-members-icon.svg" class="fm-svg" alt="Family Members" />
                                            </div>    
                                        </div>
                                    </div>
                                    <div class="col-sm-6 col-lg-4 col-xl-3">
                                        <div class="fm-white-column fm-card-icon fm-metric-card">
                                            <div class="fm-card-content">
                                                <h3 class="fm-head-32 fm-title">{{ summaryCount().totalStoryCount }}</h3>
                                                <p class="fm-large mb-0">Total Stories</p>
                                            </div>
                                            <div class="fm-metric-icon">
                                                <img src="images/icons/fm-stories-icon.svg" class="fm-svg" alt="Total Stories" />
                                            </div>    
                                        </div>
                                    </div>
                                    <div class="col-sm-6 col-lg-4 col-xl-3">
                                        <div class="fm-white-column fm-card-icon fm-metric-card">
                                            <div class="fm-card-content">
                                                <h3 class="fm-head-32 fm-title">{{ summaryCount().averageStoriesPerPersonCount }}</h3>
                                                <p class="fm-large mb-0">Avg stories per person</p>
                                            </div>
                                            <div class="fm-metric-icon">
                                                <img src="images/icons/fm-graph-up.svg" class="fm-svg" alt="Avg stories per person" />
                                            </div>    
                                        </div>
                                    </div>
                                </div>
                            </div>
                            } <!-- end data loaded -->

                            <!-- Family Tree Action Bar -->
                            <div class="fm-family-tree-topbar">
                                <h3 class="fm-head-24 fm-title">Family Tree</h3>
                                <div class="fm-family-tree-actions">
                                    <div class="fm-filter-btn-grp fm-tree-view-grp">
                                        <button
                                          type="button"
                                          class="fm-filter-cl-btn fm-tree-view-btn"
                                          [class.fm-fb-active]="viewMode() === 'tree'"
                                          (click)="setViewMode('tree')"
                                          aria-label="Tree View"
                                        >
                                            <img src="images/icons/fm-tree-icon.svg" class="fm-svg" alt="Tree View" />
                                        </button>
                                        <button
                                          type="button"
                                          class="fm-filter-cl-btn fm-tree-view-btn fm-filter-list-btn"
                                          [class.fm-fb-active]="viewMode() === 'grid'"
                                          (click)="setViewMode('grid')"
                                          aria-label="Grid View"
                                        >
                                            <img src="images/icons/fm-grid-icon.svg" class="fm-svg" alt="Grid View" />
                                        </button>
                                    </div>
                                    <button type="button" class="fm-common-btn fm-tree-action-btn"
                                      [class.fm-btn-active]="showAddMemberModal() && !editingMember()"
                                      (click)="openAddMemberModal()">
                                        <img src="images/icons/fm-plus-large.svg" class="fm-svg" alt="Plus Icon" />
                                        Add Family Members
                                    </button>
                                    <button type="button" class="fm-common-btn fm-secondary-btn fm-white-btn-txt fm-tree-action-btn"
                                      [class.fm-btn-active]="showCreateFamilyModal() && !editingFamily()"
                                      (click)="openCreateFamilyModal()">
                                        Create New Family
                                    </button>
                                </div>
                            </div>
                            <!-- Family Tree Action Bar -->

                            <!-- ── Inline: Add / Edit Family Member panel (expands below action bar) ── -->
                            @if (showAddMemberModal()) {
                              <app-add-family-member
                                [isInline]="true"
                                [familySpaceId]="activeFamilySpaceId() ?? ''"
                                [editMember]="editingMember()"
                                (memberAdded)="onMemberAdded()"
                                (closed)="closeAddMemberModal()"
                              />
                            }

                            <!-- ── Inline: Create / Edit Family panel (expands below action bar) ── -->
                            @if (showCreateFamilyModal()) {
                              <app-create-family
                                [isInline]="true"
                                [editFamily]="editingFamily()"
                                (familyCreated)="onFamilyCreated()"
                                (closed)="closeCreateFamilyModal()"
                              />
                            }

                            <!-- Family Tree Filter -->
                            <div class="fm-white-column fm-family-filter-box">
                                <div class="fm-family-filter-left">
                                    <label class="fm-family-filter-label">Viewing Family:</label>

                                    <div class="fm-family-select">
                                        <select
                                          class="form-select"
                                          [value]="activeFamilySpaceId() ?? ''"
                                          (change)="onFamilySpaceChange($any($event.target).value)"
                                        >
                                          @if (familySpaceList().length === 0) {
                                            <option value="">No families yet</option>
                                          } @else {
                                            <option value="" disabled>Select</option>
                                            @for (family of familySpaceList(); track family.id) {
                                              <option [value]="family.id">{{ family.familyName }}</option>
                                            }
                                          }
                                        </select>

                                        @if (currentUserRole()) {
                                          <span class="fm-family-select-role">{{ currentUserRole() }}</span>
                                        }
                                    </div>
                                </div>

                                <div class="fm-family-filter-right">
                                    <button type="button" class="fm-common-btn fm-secondary-btn fm-white-btn-txt fm-tree-action-btn"
                                      [class.fm-btn-active]="showCreateFamilyModal() && editingFamily()"
                                      (click)="openEditFamilyModal()">
                                        <i class="bi bi-pencil-square"></i> Edit
                                    </button>

                                    <div class="fm-family-mini-info">
                                        <img src="images/icons/fm-group-icon.svg" class="fm-svg" alt="Family Members" />
                                        <span>{{ familySpaceCountData().familyMembersCount }} Family Members</span>
                                    </div>

                                    <div class="fm-family-mini-info">
                                        <img src="images/icons/fm-video-icon.svg" class="fm-svg" alt="Stories" />
                                        <span>{{ familySpaceCountData().totalStoryCount }} Stories</span>
                                    </div>
                                </div>
                            </div>
                            <!-- Family Tree Filter End -->

                            <!-- Family Tree/Grid Wrapper Start -->
                            <div
                              class="fm-family-view-wrap"
                              id="fmFamilyViewWrap"
                              [class.fm-list-view]="viewMode() === 'grid'"
                            >

                            <!-- ── Shared: loading spinner ── -->
                            @if (isMembersLoading()) {
                              <div class="fm-white-column text-center py-5">
                                <div class="spinner-border" role="status" style="width:1.75rem;height:1.75rem;border-width:3px;">
                                  <span class="visually-hidden">Loading family members…</span>
                                </div>
                              </div>
                            } @else if (hasMembersError()) {
                              <div class="fm-white-column text-center py-4">
                                <p class="mb-0">Unable to load family members. Please try again.</p>
                              </div>
                            } @else {

                            <!-- ══════════════════════════════════════════
                                 TREE VIEW — always in DOM, CSS hides when fm-list-view
                                 ══════════════════════════════════════════ -->
                            <div class="fm-white-column fm-family-tree-wrapper" id="fmFamilyTreeWrapper">

                              @if (treeGroups().length === 0) {
                                <div class="text-center py-4">
                                  <p class="mb-0">No family members found for this family.</p>
                                </div>
                              } @else {

                                @for (group of treeGroups(); track group.levelId; let first = $first) {

                                  @if (!first) {
                                    <div class="fm-tree-line"></div>
                                  }

                                  <div class="fm-tree-group">
                                    <div class="fm-tree-group-title">
                                      <p class="mb-0">{{ group.levelName }}</p>
                                    </div>

                                    <div class="fm-tree-row" [class.fm-tree-row-large]="group.hasCurrentUser">

                                      @for (member of group.members; track member.familyMemberId) {
                                        <div class="fm-tree-member">

                                          <!-- Three-dots action menu (top-right of member cell) -->
                                          <div class="fm-tree-member-menu-wrap">
                                            <button type="button" class="fm-tree-member-menu-btn" aria-label="Actions"
                                              (click)="toggleMenu(member.familyMemberId)">
                                              <i class="bi bi-three-dots-vertical"></i>
                                            </button>
                                            @if (openMenuId() === member.familyMemberId) {
                                              <div class="fm-loved-dropdown fm-tree-dropdown">
                                                <button type="button" class="fm-dropdown-item" (click)="openEditMemberModal(member)">
                                                  <i class="bi bi-pencil"></i> Edit
                                                </button>
                                                <button type="button" class="fm-dropdown-item fm-dropdown-danger" (click)="confirmRemoveMember(member)">
                                                  <i class="bi bi-trash"></i> Remove
                                                </button>
                                              </div>
                                            }
                                          </div>

                                          <div class="fm-tree-member-image">
                                            @if (member.profilePhotoUrl) {
                                              <img
                                                [src]="member.profilePhotoUrl"
                                                [alt]="member.fullName"
                                                onerror="this.style.display='none';this.nextElementSibling.style.display='flex'"
                                              />
                                              <span class="fm-tree-member-initials" style="display:none;">
                                                {{ getInitials(member.fullName) }}
                                              </span>
                                            } @else {
                                              <span class="fm-tree-member-initials">
                                                {{ getInitials(member.fullName) }}
                                              </span>
                                            }
                                          </div>

                                          <h4 class="fm-head-18 fm-tree-member-name">
                                            @if (member.isLoggedInUser) {
                                              You ({{ member.fullName }})
                                            } @else {
                                              {{ member.fullName || '—' }}
                                            }
                                          </h4>
                                          <span>{{ member.relationship }}</span>
                                          <p [class.active-story]="member.storyCount > 0">
                                            {{ member.storyCount }} {{ member.storyCount === 1 ? 'Story' : 'Stories' }}
                                          </p>

                                        </div>
                                      }

                                    </div>
                                  </div>

                                }

                              }

                            </div>
                            <!-- Tree View End -->

                            <!-- ══════════════════════════════════════════
                                 GRID VIEW — always in DOM, CSS shows when fm-list-view
                                 ══════════════════════════════════════════ -->
                            <div class="fm-white-column fm-lovedones-grid">

                              @if (familyMembers().length === 0) {
                                <div class="text-center py-4">
                                  <p class="mb-0">No family members found for this family.</p>
                                </div>
                              } @else {
                                <div class="row g-3">
                                  @for (member of familyMembers(); track member.familyMemberId) {
                                    <div class="col-sm-6 col-xl-4 d-flex">
                                      <div class="fm-loved-card w-100">

                                        <!-- Card header -->
                                        <div class="fm-loved-card-top">
                                          <div class="fm-loved-profile">
                                            <div class="fm-loved-profile-image">
                                              @if (member.profilePhotoUrl) {
                                                <img
                                                  [src]="member.profilePhotoUrl"
                                                  [alt]="member.fullName"
                                                  onerror="this.style.display='none';this.nextElementSibling.style.display='flex'"
                                                />
                                                <span class="fm-profile-initials" style="display:none;">
                                                  {{ getInitials(member.fullName) }}
                                                </span>
                                              } @else {
                                                <span class="fm-profile-initials">
                                                  {{ getInitials(member.fullName) }}
                                                </span>
                                              }
                                            </div>
                                            <div class="fm-loved-profile-content">
                                              <h4 class="fm-head-18 fm-loved-name">
                                                @if (member.isLoggedInUser) {
                                                  You ({{ member.fullName }})
                                                } @else {
                                                  {{ member.fullName || '—' }}
                                                }
                                              </h4>
                                              <p class="fm-loved-role">
                                                {{ member.relationship || '—' }}
                                                @if (member.inviteStatus) {
                                                  <span class="fm-status {{ getInviteStatusClass(member.inviteStatus) }}">
                                                    {{ member.inviteStatus }}
                                                  </span>
                                                }
                                              </p>
                                            </div>
                                          </div>
                                          <div class="fm-loved-menu-wrap">
                                            <button type="button" class="fm-loved-menu" aria-label="More actions" (click)="toggleMenu(member.familyMemberId)">
                                              <i class="bi bi-three-dots-vertical"></i>
                                            </button>
                                            @if (openMenuId() === member.familyMemberId) {
                                              <div class="fm-loved-dropdown">
                                                <button type="button" class="fm-dropdown-item" (click)="openEditMemberModal(member)">
                                                  <i class="bi bi-pencil"></i> Edit
                                                </button>
                                                <button type="button" class="fm-dropdown-item fm-dropdown-danger" (click)="confirmRemoveMember(member)">
                                                  <i class="bi bi-trash"></i> Remove
                                                </button>
                                              </div>
                                            }
                                          </div>
                                        </div>

                                        <!-- Contact details -->
                                        <ul class="fm-loved-contact">
                                          @if (member.phoneNumber) {
                                            <li>
                                              <img src="images/icons/fm-phone-outline.svg" alt="Phone" />
                                              <span class="fm-contact-text">{{ formatPhone(member.phoneNumber) }}</span>
                                            </li>
                                          }
                                          @if (member.email) {
                                            <li>
                                              <img src="images/icons/fm-envelope-outline.svg" alt="Email" />
                                              <span class="fm-contact-text">{{ member.email }}</span>
                                            </li>
                                          }
                                          @if (!member.phoneNumber && !member.email) {
                                            <li class="text-muted" style="font-size:13px;">No contact info</li>
                                          }
                                        </ul>

                                        <!-- Stats -->
                                        <div class="fm-loved-stats">
                                          <div class="fm-loved-stat">
                                            <img src="images/icons/fm-book-icon.svg" alt="Stories" />
                                            <h5 class="fm-head-16">{{ member.storyCount }}</h5>
                                            <p>Stories</p>
                                          </div>
                                          <div class="fm-loved-stat">
                                            <img src="images/icons/fm-heart-cl.svg" alt="Reactions" />
                                            <h5 class="fm-head-16">{{ member.reactionCount }}</h5>
                                            <p>Reactions</p>
                                          </div>
                                          <div class="fm-loved-stat">
                                            <img src="images/icons/fm-eye-blue.svg" alt="Views" />
                                            <h5 class="fm-head-16">{{ member.totalViewCount }}</h5>
                                            <p>Views</p>
                                          </div>
                                        </div>

                                        <a routerLink="/app/stories" [queryParams]="{ memberId: member.familyMemberId }" class="fm-loved-btn">
                                          View Stories <i class="bi bi-arrow-right"></i>
                                        </a>

                                      </div>
                                    </div>
                                  }
                                </div>
                                @if (hasMoreRecords()) {
                                  <div class="fm-loadmore-wrap">
                                    <button
                                      type="button"
                                      class="fm-loadmore-btn"
                                      [disabled]="isLoadingMore()"
                                      (click)="loadMore()"
                                    >
                                      @if (isLoadingMore()) {
                                        Loading…
                                      } @else {
                                        Load More <i class="bi bi-arrow-down"></i>
                                      }
                                    </button>
                                  </div>
                                }
                              }

                            </div>
                            <!-- Grid View End -->

                            } <!-- end @else (data ready) -->

                            </div>
                            <!-- Family Tree/Grid Wrapper End --> 
                        </div>
                   </div> 
                </div>
            </div>
            <!-- Content Wrapper End -->

@if (memberToRemove()) {
  <app-delete-confirmation
    title="Remove Member"
    [message]="'Are you sure you want to remove <strong>' + memberToRemove()!.fullName + '</strong> from this family group?'"
    confirmButtonText="Yes, Remove"
    (confirmed)="removeMember()"
    (cancelled)="cancelRemove()"
  />
}
